import {Injectable} from '@angular/core';
import {Observable, shareReplay} from "rxjs";
import {EchUtils} from "../ech-utils/ech-utils";

@Injectable()
export class ImgServerService {

  private observable: Observable<any>;
  constructor(private echUtils: EchUtils) {
    this.observable = echUtils.getObservable("/api/sys/imageServer/getImgServer")
      .pipe(shareReplay(1));
  }

  getImgFullUrl(imgUri: any): Observable<any> {
    return new Observable(observable => {
      if (imgUri.startsWith("http://") || imgUri.startsWith("https://")) {
        observable.next(imgUri);
      } else if (imgUri.trim("")) {
        this.observable.subscribe(imgUrl => {
          observable.next(imgUrl.concat(imgUri));
        });
      }else{
        observable.next("");
      }
    });
  }
}
